// Importing countries
import { COUNTRIES_EN } from './countries';

export const LANG_DA_CODE = 'da-DA';
export const LANG_DA_NAME = 'Dan';
export const LANG_DA_COMPLETE_NAME = 'Dansk';

const LANG_DA = {
  'en-US': 'English',
  'es-ES': 'Español',
  'da-DA': 'Dansk',
  'fr-FR': 'Français',
  'fr-CA': 'Français (Canada)',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  'ENGLISH': 'English',
  'SPANISH': 'Español',
  'DANISH': 'Dansk',
  'FRENCH': 'Français',
  'CANADIAN FRENCH': 'Français (Canada)',
  'GERMAN': 'Deutsch',
  'DUTCH': 'Nederlands',
  'MORE_INFO': 'Læs mere',
  // =========== LOGIN ===========
  // =============================
  'HOME': {
    'TITLE': 'Gruppeviden er Magt',
    'TEXT': 'Concept Systems Incorporated giver organisationer, som arbejder med enhver form for samarbejdsinitiativ, de bedste metoder til at kortlægge fælles indsigter set fra forskellige perspektiver.'
  },
  'AUTO_LOGOUT': {
    'WARNING': {
      'TITLE': 'Er du der stadig?',
      'BUTTON': 'Fortsæt med at arbejde',
      'MESSAGE': 'Af sikkerhedsmæssige årsager vil du blive logget af, hvis du inaktiv efter ',
      'SECONDS': 'sekunder'
    }
  },
  'LOGIN': {
    'USERNAME': 'Brugernavn',
    'USERNAME_OR_EMAIL': 'BRUGERNAVN ELLER E-MAIL',
    'OR': 'eller',
    'ACTIVATE_ACCOUNT': 'Aktivér konto',
    'ACTIVATE_ACCOUNT_TEXT': 'Opret en konto, og bidrag på en nem måde til vigtige projekter!',
    'ASSIGNED_USERNAME': 'TILDELT BRUGERNAVN',
    'YOUR_USERNAME': 'DIT BRUGERNAVN',
    'ANONYMOUS_ACCOUNT': 'Anonym konto',
    'DIFFERENT_EMAIL': 'Jeg vil bruge en anden e-mail',
    'PASSWORD': 'ADGANGSKODE',
    'FORGOT_PASSWORD': 'Glemt adgangskode?',
    'LOCKED_ACCOUNT': '* Din konto er blevet låst. Kontakt venligst projektgruppen for hjælp.',
    'INVALID_USER': 'Ugyldigt brugernavn eller adgangskode. Prøv igen, eller kontakt projektgruppen for hjælp.',
    'WRONG_PASSWORD_1': 'Forkert adgangskode. Du har 1 forsøg tilbage.',
    'WRONG_PASSWORD': 'Forkert adgangskode. Du har ',
    'MORE_TRIES': '  forsøg tilbage!',
    'RESET_PASSWORD': 'Nulstil adgangskode',
    'DONE': 'FÆRDIG',
    'INVITE_PROMPT': 'Du er blevet inviteret til at deltage i et nyt projekt',
    'INVITE_PROCEED': 'gå videre til projektet',
    'HAVE_ACCOUNT': 'Har du allerede en konto?',
    'ASSIGNED_ACCOUNT': 'Hvis du har et TILDELT brugernavn og adgangskode,',
    'ASSIGNED_LINK': 'KLIK HER',
    'LOGIN_HERE': 'Log ind her',
    'RESET_EXPIRE': 'Dit link til nulstilling af adgangskode er udløbet. Anmod  om en ny herunder for at nulstille din adgangskode.',
    'RESEND': 'SEND IGEN',
    'PWD_CONFIRMATION': 'Bekræftelse af ny adgangskode.',
    'PDW_CHANGE_SUCCESSFULLY': 'Din adgangskode er blevet ændret.',
    'CONTINUE': 'FORTSÆT',
    'CREATE_PASSWORD': 'Opret adgangskode',
    'CREATE_ACCOUNT': 'Opret konto',
    'CP_SUBTITLE': 'Angiv en adgangskode til din anonyme konto.',
    'CP_SUBTITLE_USERNAME': 'Angiv en adgangskode til dit tildelte brugernavn.',
    'CP_SUBTITLE_EMAIL': 'Angiv en adgangskode til din e-mail.',
    'ANONYMOUS_SUGGESTION_TEXT': 'Vi anbefaler kraftigt, at du skriver dette ned.',
    'WHY': 'Hvorfor?',
    'CONFIRM_PASSWORD': 'BEKRÆFT ADGANGSKODE',
    'LOG_IN': 'Log ind',
    'FINISH_SU_ACCOUNT': 'Afslut opsætningen af din konto',
    'EMAIL': 'E-MAIL',
    'CHECK_INBOX': 'Tjek din indbakke.',
    'EMAIL_TEXT_NOTIFICATION': 'Vi har sendt en e-mail til',
    'EMAIL_TEXT_NOTIFICATION_2': 'med et link til at aktivere din konto.',
    'CLICK_LINK': 'Klik på linket, og du er klar til at gå i gang.',
    'BACK_LOGIN': 'Tilbage til log ind-siden.',
    'SEND_EMAIL_TEXT_NOTIFICATION': 'Vi sender dig en e-mail med instruktioner om, hvordan du nulstiller din adgangskode, til følgende adresse:',
    'FP_EMAIL_TEXT_NOTIFICATION': 'Der er en e-mail er på vej til dig! Du vil snart modtage instruktioner om, hvordan du nulstiller din adgangskode. Sørg for at tjekke din spam-mappe (for en sikkerheds skyld).',
    'DIDNT_GET_EMAIL': 'Modtog du ikke e-mailen?',
    'RESEND_LINK': 'Send linket igen.',
    'RESET_PASSWORD_SUCCESS': 'Kontakt projektgruppen for at nulstille din adgangskode.',
    'NO_ACTIVITIES': {
      'OOPS': 'Hov!',
      'TEXT_MAIN': 'Det ser ud til, at dette projekt har nået grænsen for, hvor mange deltagere der er brug for.<br><br> ' +
      'Kontakt projektadministratoren, hvis du har spørgsmål <a href="mailto:support@conceptsystems.com">!',
      'TEXT_NO_ACTIVITIES': 'Der er i øjeblikket ingen opgaver tilknyttet denne invitation. <br><br> Kontakt projektadministratoren, hvis du har spørgsmål.',
    },
    'INFO_REGISTER_IDENTIFIER': 'Projektadministratoren vil kunne sende dig en e-mail via systemet baseret på din deltagelsesstatus. Ingen vil dog kunne se din e-mail-adresse.',
    'BROKEN_LINK': {
      'INFORMATION': 'Information:',
      'PROJECT_CONTACT': 'Kontaktperson for dette projekt:',
      'CAUSE': 'Det link, du brugte, er ugyldigt – klik på det oprindelige link, og prøv igen.',
      'TEXT': 'Kontakt projektadministratoren, hvis du har spørgsmål.',
    },
    'CERATE_ACCOUNT': 'OPRET KONTO',
    'CREATE_ACCOUNT_IDENTIFIER': {
      'TITLE_CREATE': 'Opret en konto',
      'TITLE_START': 'og begynd at bidrage med dine svar.',
      'STUDENT_ID': 'ID FRA UDDANNELSESINSTITUTION',
      'EMAIL': 'E-MAIL',
      'EMAIL_INFO': 'Din e-mail vil ikke være synlig for projektgruppen.',
      'CREATE_A_PASSWORD': 'OPRET ADGANGSKODE',
      'STRONG': 'Stærk',
      'WEAK': 'Svag',
      'INVALID_USERNAME': 'Ugyldigt brugernavn, prøv igen.',
      'INCOMPLETE_USERNAME': 'Du skal indtaste et brugernavn.',
      'USERNAME': 'Brugernavn',
      'CHARACTERS_MINIMUM': 'Din adgangskode skal indeholde mindst 6 tegn.',
      'SAME_USERNAME': 'Din adgangskode kan ikke være det samme som dit brugernavn.',
      'MISSING_DIGIT': 'Din adgangskode skal indeholde mindst ét ​​tal',
      'MISSING_UPPERCASE': 'Din adgangskode skal indeholde mindst ét ​​stort bogstav',
      'MISSING_LOWERCASE': 'Din adgangskode skal indeholde mindst ét ​​lille tegn',
      'MISSING_SYMBOL': 'Din adgangskode skal indeholde mindst ét ​​ikke-alfabetisk tegn',
      'PASSWORD_MAX': 'Du skal indtaste en adgangskode.',
      'PASSWORD_PLACEHOLDER': 'Indtast adgangskode',
      'SECURE_PASSWORD': 'En sikker adgangskode skal som minimum indeholde:',
      'BASE_DIGIT': 'et tal (0 til 9)',
      'UPPERCASE_CHARACTER': 'et stort bogstav (a til z)',
      'LOWERCASE_CHARACTER': 'et lille bogstav (a til z)',
      'ALPHABETIC_CHARACTER': 'et specialtegn (fx !, $, %, #)',
      'MUST_PASSWORD_AGAIN': 'Du skal indtaste din adgangskode igen.',
      'PASSWORD_NOT_MATCH': 'Adgangskoderne stemmer ikke overens.',
      'PASSWORD_AGAIN': 'Indtast adgangskode igen.',
    }
  },
  // ========= AUTOSAVE ==========
  // =============================
  'SAVING_STATUS': {
    'SAVED': 'Alle ændringer er blevet gemt.',
    'SAVING': 'Gem',
  },
  // ==== MY PROJECTS ===========
  // ============================
  'MY_PROJECTS': {
    'TITLE': 'Mine projekter',
    'TEXT': 'Klik på et projekt for at fuldføre dine tildelte aktiviteter.',
    'NO_PROJECT': {
      'TITLE': 'Hov!',
      'TEXT': 'Du er i øjeblikket ikke tilknyttet nogen åbne projektaktiviteter.',
    }
  },
  // ==== SYSTEM ERROR ===========
  // ============================
  'SYSTEM_ERROR': {
    'TITLE': 'Uventet systemfejl',
    'MESSAGE': {
      'TITLE': 'Hov!',
      'TEXT': 'Uventet systemfejl. Prøv igen om nogle få minutter. Hvis fejlen fortsætter, så kontakt ',
      'EMAIL': 'support@conceptsystems.com',
    }
  },
  // ==== MY ACCOUNT ===========
  // ============================
  'MY_ACCOUNT': {
    'TITLE': 'Min konto',
    'INFORMATION': 'Dine kontoinformationer',
    'USERNAME': 'Brugernavn',
    'EMAIL': 'E-mail',
    'PERSONAL_DETAILS': 'Personlige oplysninger',
    'FIRST_NAME': 'Fornavn',
    'EDIT': 'Rediger',
    'SAVE': 'Gem',
    'LAST_NAME': 'Efternavn',
    'CHANGE_PASSWORD': 'Skrift adgangskode',
    'DONT_SEND_EMAIL': 'Send mig ikke e-mails fra Group Wisdom<sup>tm</sup>',
    'CURRENT_PASSWORD': 'Nuværende adgangskode',
    'NEW_PASSWORD': 'Ny adgangskode',
    'CONFIRM_PASSWORD': 'Bekræft adgangskode',
    'CHANGED': 'Ændret:',
    'ANONYMOUS_ACCOUNT': 'Anonym konto',
    'TERMS': {
      'SHOW': 'Vis',
      'LABEL': 'Group Wisdom<sup>tm</sup> betingelser'
    },
    'PRIVACY': {
      'SHOW': 'Vis',
      'LABEL': 'Group Wisdom<sup>tm</sup> privatliv'
    },
    'ANONYMOUS_TOOLTIP': 'Ved anonyme konti kendes din identitet ikke af projektgruppen.'
  },
  // ==== HEADER  =================
  // =============================
  'HEADER': {
    'MY_PROJECTS': 'Projekter',
    'MY_ACCOUNT': 'Konto',
    'NOTIFICATIONS': 'Meddelelser',
    'HELP_AND_SUPPORT': 'Hjælp og support',
    'SIGN_OUT': 'Log ud',
    'CHOSE_LANGUAGE': 'Vælg sprog:'
  },
  // ==== FOOTER =================
  // =============================
  'FOOTER': {
    'ITEMS': {
      'PRIVACY': 'Privatliv',
      'TERMS': 'Betingelser',
      'HELP': 'Hjælp og support'
    },
    'COPYRIGHT': 'Copyright © 2000-2023. Alle rettigheder forbeholdes. Drevet af',
    'COPYRIGHT_STRING': 'Concept Systems, Inc'
  },
  // ==== NOTIFICATIONS =================
  // =============================
  'NOTIFICATIONS': {
    'TITLE' : 'MEDDELELSER ',
    'TITLE_NO' : 'INGEN NYE MEDDELELSER',
    'TITLE_SINGLE' : 'EN NY MEDDELELSE',
    'TITLE_MULTIPLE' : 'NYE MEDDELELSER',
    'ALL': 'ALLE MEDDELELSER',
    'PAGER': {
      'SHOWING': 'VISER',
      'TO' : 'TIL',
    },
    'NOTIFICATION': 'Meddelelse',
    'FROM': 'Fra: ',
  },
  // ==== INFORMED CONSENT MODAL ===========
  // =======================================
  'INFORMED_CONSENT_MODAL': {
    'TITLE': 'Samtykke til at deltage',
    'DOWNLOAD': 'Download samtykkeerklæring',
    'UPLOAD': 'Upload underskrevet samtykkeerklæring',
    'TOOLTIP': 'Underskriv samtykkeerklæringen, og upload den for at fortsætte med at deltage i projektet.',
    'ACCEPT': 'ACCEPTER',
    'DECLINE': 'AFVIS',
    'FILE_ERROR': {
      'TYPE': 'Samtykkeerklæringen kan kun uploades som .pdf, .doc, .docx.',
      'SIZE': 'Størrelsen på filen må maksimalt være 10 MB, prøv igen.',
    },
    'NO_DATA': 'Du har ikke afgivet samtykke til at deltage.'
  },
  // ==== THANK YOU MODAL ===========
  // =======================================
  'THANK_YOU_MODAL': {
    'BUTTON_LINK': 'NÆSTE'
  },
  // ==== DECLINE INFORMED CONSENT MODAL ========
  // ============================================
  'DECLINE_ICM': {
    'TITLE': 'Du afviste samtykkeerklæringen',
    'TEXT': 'Du kan desværre ikke gå videre til projektets opgaver, hvis du ikke accepterer det samtykke til at deltage.',
    'TEXT_1': 'Kontakt projektgruppen, hvis du har spørgsmål.',
    'CONTINUE': 'FORTSÆT',
    'SING_OUT': 'Log ud'
  },
  // ====== PROJECT ===========================
  // ==========================================
  'PROJECT': {
    'SHOW_PI': 'Vis projektinformation',
    'VIEW_IC': 'Se samtykke til at deltage',
    'AVAILABLE_ACTIVITIES': 'DINE TILGÆNGELIGE OPGAVER',
    'AVAILABLE_ACTIVITIES_TOOLTIP': 'Klik på en åben, påbegyndt eller afsluttet opgave for at se den pågældende opgave ' +
    'En opgave, som ikke tidligere er påbegyndt, vises som åben ' +
    'Hvis den ikke er afsluttet, vises med som påbegyndt. Når en opgave er blevet markeret som færdig, vises den som afsluttet.',
    'PROJECT_INFO_MODAL': {
      'TITLE': 'Kontaktinformation for dette projekt',
      'PHONE': 'Telefonnummer:',
      'EMAIL': 'E-mail:',
      'NO_DATA': 'Der er ingen kontaktinformationer for dette projekt.'
    },
    'PREVIEW': {
      'EXIT_TITLE': 'Du ser en forhåndsvisning af, hvad en deltager vil se.',
      'EXIT_BUTTON': 'Afslut forhåndsvisning'
    },
    'NO_ACTIVITIES': {
      'OOPS': 'Hov!',
      'TEXT_MAIN': 'Det ser ud til, at dette projekt har nået grænsen for, hvor mange deltagere der er brug for.',
      'TEXT': 'Du har ingen tildelte opgaver.'
    },
    'BRAINSTORMING': 'Brainstorm',
    'SORTING': 'Sortering',
    'RATING': 'Vurdering',
    'PQ': 'Baggrundsspørgsmål',
    'CLOSES': 'Luk'
  },
  // ==== BRAINSTORMING ========
  // ============================================
  'BRAINSTORMING': {
    'TITLE': 'Brainstorm',
    'INFO': 'Information',
    'INFORMATION': 'Tænk nøje over dine svar. Med udgangspunkt i fokusspørgsmålet kan du tilføje svar, som repræsenterer dine overvejelser og erfaringer.',
    'ADD_IDEAS': 'Tilføj svar',
    'COLLECTED_STATEMENTS': 'Indsamlede svar:',
    'COLLECTED_STATEMENTS_TOOLTIP': 'Disse svar er indsamlet via brainstorm-processen. Listen opdateres, hver gang du tilføjer et svar eller trykker på Opdater liste',
    'REFRESH': 'Opdater liste',
    'FINISH': 'Afslut',
    'STATEMENTS': {
      'ADD': 'Tilføj svar',
      'NEW_STATEMENT_PLACEHOLDER': 'Indtast for at tilføje et svar',
    },
    'ACTIONS': {
      'SEARCH': {
        'PLACEHOLDER': 'Søg',
      }
    },
    'FOCUS_PROMPT': 'FOKUSSPØRGSMÅL',
    'MOBILE_STATEMENTS': 'svar',
    'COLLECTED': 'indsamlet',
    'FOCUS_PROMPT_TOOLTIP': 'Dette fokusspørgsmål skal hjælpe dig til at tilføje de svar, som skal bruges i projektets videre forløb.',
    'HIDE_PROMPT': 'Skjul fokusspørgsmål',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Vis introduktion',
      'SHOW_TOUR_AGAIN': 'Vis instruktionen igen',
      'LEAVE': 'Forlad brainstorm-processen',
      'FINISH': 'Afslut brainstorm-processen'
    },
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'START'
      },
      'LIMIT': {
        'TITLE': 'Svargrænse',
        'DESCRIPTION': 'Grænsen for antal svar er nået. Du kan ikke tilføje flere svar.',
        'BUTTON': 'LUK'
      }
    },
    'PROJECT_HOME': 'Projektets startside',
    'RETURN': 'Vend tilbage til',
    'THANK_YOU': {
      'TITLE': 'Mange tak',
      'BUTTON': 'VEND TILBAGE TIL PROJEKTETS STARTSIDE',
      'BUTTON_LINK': 'NÆSTE'
    },
    'TEXTAREA': {
      'PLACEHOLDER': 'Tryk for at tilføje et svar'
    },
    'CHARACTERS_LEFT': 'tegn tilbage'
  },
  // === PARTICIPANT QUESTIONS ===
  // =============================
  'PARTICIPANT_QUESTIONS': {
    'TITLE': 'Baggrundsspørgsmål',
    'PAGE': 'Side',
    'OF': 'af',
    'FINISH': 'Færdig',
    'BACK': 'Tilbage',
    'NEXT': 'Næste',
    'DECIMALS_ALLOWED': 'Op til %0 decimaler er tilladt.',
    'RANGE': 'Min: %0  Max: %1',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Vis introduktion',
      'LEAVE_QUESTIONS': 'Forlad besvarelsen',
      'FINISH_QUESTIONS': 'Afslut besvarelsen'
    },
    'TEXTAREA_PLACEHOLDER': 'Skriv dit svar her',
    'SELECT': 'Vælg svarmulighed',
    'HOLD_MODAL': {
      'TITLE': 'Vent venligst',
      'DESCRIPTION': 'Du skal besvare alle nødvendige spørgsmål for at afslutte.',
      'BUTTON': 'FORTSÆT',
      'LEAVE_QUESTIONS_AND_RETURN_LATER': 'Forlad besvarelsen, og vend tilbage senere.'
    },
    'INTRODUCTION_MODAL': {
      'TITLE': 'Baggrundsspørgsmål',
      'BUTTON': 'START'
    },
    'PROJECT_HOME': 'Projektets startside',
    'RETURN': 'Vend tilbage til',
    'THANK_YOU': {
      'TITLE': 'Tak',
      'BUTTON': 'VEND TILBAGE TIL PROJEKTETS STARTSIDE',
      'BUTTON_LINK': 'NÆSTE'
    },
    'OOPS': {
      'TITLE': 'Hov!',
      'MESSAGE': 'Der er ingen baggrundsspørgsmål forbundet med dette projekt.'
    },
    'OTHER': {
      'DEFAULT': 'Andre',
      'PLACEHOLDER': 'Skriv dit svar her'
    },
    'CHARACTERS_LEFT': 'tegn tilbage',
    'ERRORS': {
      'NUMERIC': 'Svaret skal ligge mellem minimum- og maksimumværdierne og må ikke overstige antallet af angivne decimaler.'
    },
    'REQUIRED_FIELD': '* Felt skal udfyldes'
  },
  // ====== RATING ===========================
  // ==========================================
  'RATING': {
    'RATING': 'VURDERING',
    'SHOW_INTRO': 'Vis introduktion',
    'LEAVE_QUESTION': 'Forlad baggrundsspørgsmål',
    'FINISH_QUESTION': 'Afslut baggrundsspørgsmål',
    'FOCUS_PROMPT': 'FOKUSSPØRGSMÅL',
    'FINISH': 'Afslut',
    'OF': 'af',
    'STATEMENTS': 'svar',
    'RATED': 'vurderet',
    'HIDE_PROMPT': 'Skjul fokusspørgsmål',
    'IMPORTANCE': 'VIGTIGHED',
    'CHOOSE_RATING': 'Angiv din vurdering',
    'SELECT_RATING': 'VÆLG VURDERING',
    'DECIMALS_ALLOWED': 'Op til to decimaler er tilladt.',
    'MIN': 'Minimum',
    'MAX': 'Maksimum',
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'START',
      },
      'FINISH': {
        'TITLE': 'Afslut opgave',
        'DESCRIPTION': 'Opgaven er allerede afsluttet',
        'ACTIONS': {
          'CONTINUE': 'FORTSÆT',
          'LINK': 'Forlad sorteringen, og vend tilbage senere.'
        }
      }
    },
    'PROJECT_HOME': 'Projektets startside',
    'RETURN': 'Tilbage til',
    'THANK_YOU': {
      'TITLE': 'Tak',
      'BUTTON': 'VEND TILBAGE TIL PROJEKTETS STARTSIDE',
      'BUTTON_LINK': 'NÆSTE'
    },
    'STATEMENTS_LIST': {
      'PAGE': 'Side',
      'OF': 'af',
      'STATEMENTS': 'Svar',
      'TO': 'til',
      'ON': 'På',
      'ON_PAGE': 'På side:',
      'ALL': 'Alle',
      'UNRATED': 'Ikke vurderet',
      'RATED': 'Er vurderet',
      'BACK': 'TILBAGE',
      'NEXT': 'NÆSTE'
    },
    'VALIDATION_ERROR': 'Vurderingen skal ligge mellem minimum- og maksimumværdierne.',
    'UNRATE': 'Slet vurdering'
  },
  // ========== SORTING ==========
  // =============================
  'SORTING': {
    'TITLE': 'Sortering',
    'CARDS': {
      'TITLE': 'Kort',
      'MORE': 'mere',
      'LESS': 'mindre',
      'ALL': 'Alle',
      'UNSORTED': 'Usorterede',
      'SORTED': 'Sorterede',
      'PILES': 'Bunker',
      'SORT_IN': 'sorter i',
      'IN_PILE': 'i bunken',
      'UNIQUE': 'kort',
      'MULTIPLE': 'kort'
    },
    'INTRODUCTION': 'Klik og flyt kortene for at lave bunker',
    'OF': 'af',
    'STATEMENTS': 'svar',
    'SORTED': 'sorteret',
    'AUTO_SAVE': 'Alle ændringer er gemt.',
    'FINISH': 'FÆRDIG',
    'EXPAND_ALL': 'Udvid alle',
    'COLLAPSE_ALL': 'Skjul alle',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Vis introduktion',
      'SHOW_TOUR_AGAIN': 'Vis gennemgang igen',
      'LEAVE_SORTING': 'Forlad sorteringen',
      'FINISH_SORTING': 'Afslut sorteringen'
    },
    'MODAL': {
      'LANDSCAPE': {
        'MESSAGE': 'Placer din tablet i vandret tilstand for den bedste brugeroplevelse.'
      },
      'INTRODUCTION': {
        'BUTTON': 'START'
      },
      'DELETE_PILE': {
        'TITLE': 'Slet bunken',
        'DESCRIPTION': 'Er du sikker på, at du vil slette den valgte bunke?',
        'BUTTONS': {
          'CANCEL': 'ANNULLER',
          'YES': 'JA'
        }
      },
      'FINISH': {
        'TITLE': 'Beklager',
        'DESCRIPTION': 'Du skal sortere mindst %0 kort, før du kan afslutte.',
        'ACTIONS': {
          'CONTINUE': 'FORTSÆT',
          'LINK': 'Forlad sorteringen, og vend tilbage senere.'
        }
      },
      'SORT_IN': {
        'NEW_PILE': 'NY BUNKE',
        'PLACEHOLDER': 'Angiv en titel',
        'NO_PILES': 'Ingen kort er lagt i bunker.',
        'SORT': 'SORTER',
        'SEND': 'SEND',
        'CARD': 'KORT %0',
        'INTO': 'I…',
        'TO_PILE': 'TIL BUNKEN',
        'CREATE_NEW_PILE': '+ Lav ny bunke',
        'SAVE_NEW_PILE': 'Gem',
        'CANCEL': '< Tilbage til svarene',
        'SAVE': 'GEM',
        'SUCCESS': 'Kortet blev lagt i bunken.',
        'NAMING': 'Det er VIGTIGT, at bunkerne gives en TITEL!',
        'ERROR_HELPER_PILE_NAME': 'Du skal give denne bunke en titel.'
      },
      'PILE': {
        'TITLE': 'BUNKE',
        'VIEW': 'Se kortene i denne bunke',
        'EDIT': 'Rediger bunkens titel',
        'DELETE': 'Slet bunken',
        'CANCEL': '< Tilbage til bunkerne',
        'SAVE': 'GEM',
        'CREATE': 'Lav bunke'
      }
    },
    'FOCUS_PROMPT': {
      'TITLE': 'FOKUSPØRGSMÅL:',
      'SUB_TITLE': 'For at skabe et samfund, hvor folks sundhedstilstand er højere, bør vi ...',
      'HIDE_PROMPT': 'Skjul fokusspørgsmål'
    },
    'DROP': {
      'CREATE': 'Slip kortet for at lave en bunke',
      'NEW': 'ny bunke'
    },
    'DELETE_PILE': 'slet bunken',
    'DROP_TO_CREATE': 'Slip kortet for at lave en bunke',
    'NEW_PILE': 'ny bunke',
    'PILE_PLACEHOLDER': 'Angiv bunkens titel',
    'PROJECT_HOME': 'Projektets startside',
    'RETURN': 'Gå tilbage til',
    'THANK_YOU': {
      'TITLE': 'Mange tak',
      'BUTTON': 'VEND TILBAGE TIL PROJEKTETS STARTSIDE',
      'BUTTON_LINK': 'NÆSTE'
    },
    'REVIEW': {
      'TITLE': 'Du er næsten færdig!',
      'UNNAMED': 'Bunker uden titler',
      'ALL_NAMED': 'Alle bunker har fået en titel!',
      'ALL_NAMED_DESCRIPTION': 'Klik på \'Færdig\' for at afslutte aktiviteten.',
      'REVIEW': 'gennemgå',
      'DONE': 'Færdig',
      'FINISH': 'Afslut uden at angive titel',
      'BACK': 'Tilbage til sortering',
      'ACTIONS': {
        'OK': 'OK',
        'TRY_USING': 'Prøv at bruge',
        'OR': 'eller',
        'SWITCH': 'skrift til bunken'
      }
    },
    'PILES': {
      'NO_SORTED': 'Ingen svar er blevet sorteret i bunker.'
    }
  },
  'HELP_SUPPORT': {
    'TITLE': 'Hjælp og support',
    'SUBTITLE': 'Hvad har du brug for hjælp til?',
    'CONTACT': {
      'TECHNICAL': 'Teknisk support:',
      'SEND_MESSAGE': 'Send os en besked',
      'GET_BACK': 'Vi vender tilbage til dig hurtigst muligt!',
      'PROJECT': 'PROJEKT',
      'EMAIL_PHONE': 'KONTAKT-E-MAIL ELLER TELEFONNUMMER',
      'OPTIONAL': 'Valgfrit',
      'TOPIC': 'EMNE',
      'ADDITIONAL_INFO': 'YDERLIGERE information',
      'LET_US': 'Fortæl os, hvilken opgave du har problemer med. Skriv så mange oplysninger som muligt.',
      'SUCCESS': 'Din meddelelse er sendt.',
      'CONTACT_ERROR': 'Tjek den e-mail eller telefonnummer, der er indtastet.'
    },
    'MODAL': {
      'TITLE': 'Beskeden kunne ikke sendes.',
      'TEXT': 'Vi har ikke registreret en kontaktperson for dette projekt.',
      'CONTACT': 'Du kan kontakte teknisk support eller sende en e-mail til support@conceptsystems.com.',
      'OK': 'OK'
    },
    'MOST_FREQUENT': 'Ofte stillede spørgsmål',
    'PQ': 'Baggrundsspørgsmål',
    'BS': 'Brainstorm',
    'TST': 'Sortering med kort',
    'DST': 'Sortering med rullemenuer',
    'RT': 'Vurderingsspørgsmål',
    'CONTACT_US': 'Kontakt os',
    'FOR': 'for',
    'PLACEHOLDER': 'The Future Foundation'
  },
  'FIRST_LOGIN': {
    'LINKS': {
      'PRIVACY': 'Privatliv',
      'TERMS': 'Betingelser'
    }
  },
  'FORMS': {
    'PASSWORD_REQUIREMENTS': {
      'TITLE': 'En sikker adgangskode skal mindst indeholde:',
    }
  },
  'LOCK': {
    'TITLE': 'Afslut alle nødvendige spørgsmål først.',
    'MESSAGE': 'Du skal udfylde alle nødvendige spørgsmål for at afslutte opgaven. Ellers kan du forlade systemet og vende tilbage senere.'
  },
  'BUBBLE': {
    'SKIP_INTRO': 'Spring over',
    'BACK': 'Tilbage',
    'NEXT': 'Næste',
    'DONE': 'Færdig'
  }
};

export const LANG_DA_TRANS = Object.assign(LANG_DA, COUNTRIES_EN);



// WEBPACK FOOTER //
// ./src/app/translation/i18n/lang-da.ts